import React from 'react';

import { applicationTitles } from '../../localization/en-us/applicationTitles';

import classes from './Title.module.css';

const admin = () => (
    <div className={classes.TitleBox}>
        <img src="/assets/images/devPortalColorIcon.svg" alt="" />
        <p>{applicationTitles.devPortal}</p>
    </div>
);


export default admin;
